import {useEffect, useState} from "react";
import {Form, Input, message, Select} from "antd";
import {STriggerModal} from 'shj-components'
import {addDealkingLifeSpace, editDealkingLifeSpace} from "@/services/talkOrder";

const {TextArea} = Input
const { Option } = Select

interface addOrEditProps {
  record?: any
  reload: () => void;
  onClose: () => void;
}

const AddOrEditSpaceTypeManagement = (props: addOrEditProps) => {
  const [submitLoading, setSubmitLoading] = useState(false);
  const { record, reload, onClose } = props;
  const [form] = Form.useForm();
  const spaceTypeList = [
    {
      label: '空间类',
      value: 'space'
    },
    {
      label: '非空间类',
      value: 'unSpace'
    },
  ]
  
  useEffect(() => {
    if (record?.id) form?.setFieldsValue({...record})
  },[])
  
  
  const onFinish = () => {
    form.validateFields().then((values: any) => {
      const newValues = { ...values };
      setSubmitLoading(true);
      const apiUrl = record?.id ? editDealkingLifeSpace : addDealkingLifeSpace
      if (record?.id) newValues.id = record?.id
      apiUrl(newValues).then((res: any) => {
        message.success('操作成功');
        onClose?.()
        reload?.()
      }).finally(() => setSubmitLoading(false))
    })
  };
  
  return (
    <STriggerModal
      title={record?.id ? '编辑' : '新增'}
      open={true}
      cancelText='取消'
      okText='保存'
      onOk={onFinish}
      onCancel={onClose}
      confirmLoading={submitLoading}
    >
      <Form form={form} layout="vertical" autoComplete="off">
        <Form.Item label="空间类型编码" name="code" rules={[{ required: true, message: '不能为空' }]}>
          <Input placeholder='请输入空间类型编码' maxLength={20} disabled={record?.id} />
        </Form.Item>
        <Form.Item label="空间类型名称" name="name" rules={[{ required: true, message: '不能为空' }]}>
          <Input placeholder='请输入空间类型名称' maxLength={20} />
        </Form.Item>
        <Form.Item label="所属空间类型" name="type" rules={[{ required: true, message: '不能为空' }]}>
          <Select
            placeholder="请选择所属空间类型"
            allowClear
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) => option?.children?.toLowerCase().indexOf(input?.toLowerCase()) >= 0}
          >
            {
              spaceTypeList?.map((item: any) => {
                return (
                  <Option key={item.value} value={item.value}>
                    {item.label}
                  </Option>
                );
              })}
          </Select>
        </Form.Item>
        <Form.Item label="备注" name="remark">
          <TextArea maxLength={300} placeholder='请输入备注' rows={3} />
        </Form.Item>
      </Form>
    </STriggerModal>
  )
}

export default AddOrEditSpaceTypeManagement